import 'uni-pages';
// @ts-ignore
wx.__webpack_require_UNI_MP_PLUGIN__ = __webpack_require__;import App from './App'
import Vue from 'vue'
import uView from "uview-ui";
import store from './store/index.js'

import './uni.promisify.adaptor'
Vue.config.productionTip = false
App.mpType = 'app'

Vue.prototype.$store = store;


Vue.prototype.$baseUrl = 'http://192.168.1.22:12015/'
// Vue.prototype.$baseUrl = 'http://192.168.1.85:12015/'
// Vue.prototype.$baseUrl = 'http://192.168.0.7/dmmall_web_api/'
// Vue.prototype.$baseUrl = 'https://test.doumee.cn/dmmall_web_api/'
// Vue.prototype.$baseUrl = 'http://xiaopiqiu2.natapp1.cc/'
// Vue.prototype.$baseUrl = 'https://dynometaie.com/dmmall_web_api/'
// Vue.prototype.$baseUrl = 'https://mall.dynometacn.com/dmmall_web_api/'

Vue.prototype.$onLaunched = new Promise(resolve => {
	Vue.prototype.$isResolve = resolve
})

Vue.use(uView);

store.dispatch('getHeight')
import shareMixin from '@/utils/shareMixin'
Vue.mixin(shareMixin)
const app = new Vue({
	store,
	...App
})

// http接口API抽离
import httpApi from '@/utils/http.api.js'
Vue.use(httpApi, app)

// 请求拦截器
import interceptor from '@/utils/http.interceptor.js'
Vue.use(interceptor, app)

app.$mount()